import { ViewFactory } from 'src/3rds/cube-react'

import { TemplatesScope } from '../Templates.scopes'
import TemplatesView from './Templates.view'

export { TemplatesView } from './Templates.view'

export function registerViews(rv = ViewFactory.register) {
    rv(TemplatesScope, TemplatesView)
}
